import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';
import type { OrderStatus } from '@/types/api';

const variantMap: Record<
  OrderStatus,
  | 'default'
  | 'secondary'
  | 'destructive'
  | 'success'
  | 'warning'
  | 'wine'
  | 'wineSolid'
  | 'successSoft'
  | 'warningSoft'
  | 'destructiveSoft'
  | 'muted'
> = {
  pending_payment: 'muted',
  paid: 'wine',
  pending: 'warningSoft',
  preparing: 'wineSolid',
  completed: 'successSoft',
  cancelled: 'destructiveSoft',
  error: 'destructiveSoft',
};

export function StatusBadge({ status }: { status: OrderStatus }) {
  const { t } = useTranslation();
  return <Badge variant={variantMap[status]}>{t(`orders.status.${status}`)}</Badge>;
}
